import { Grid } from '@material-ui/core';
import Information from './Information';
import Divider from '../../components/overrides/Divider';
import ContactInfo from './ContactInfo';
import { makeStyles } from '@material-ui/styles';
import DetailedLayout from './DetailedLayout';
import { TIME_AVAILABILITY_TYPES } from '../venueAvailability/timeAvailabilityTypes';
import { BREAKPOINT_VALUES } from '../../utils/constants/Breakpoints';
import clsx from 'clsx';
import { useViewport } from '../../utils/useViewport';
import { PAGE_TYPE } from '../../utils/pageTypeHelper.js';

const useStyles = makeStyles((theme) => ({
  desktopContainer: {
    width: '100%',
  },
  desktopContent: {
    maxWidth: 1200,
    display: 'flex',
  },
  desktopSidebar: {
    display: 'inline-block',
  },
  desktopDivider: {
    width: ({ type }) => {
      if (type === TIME_AVAILABILITY_TYPES.HORIZONTAL)
        return 'calc(100% - 56px)';
    },
  },
  desktopGridContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  venueInformationContainer: {
    marginRight: theme.spacing(4),
  },
  desktopContentPadding: {
    padding: theme.spacing(0, 3),
  },
}));

const DesktopVenueLayout = ({
  venue,
  handleClick,
  date,
  time,
  user,
  guests,
  list,
  loadingAvailability,
  hasRelatedEvents = false,
  eventList,
}) => {
  const classes = useStyles({ type: TIME_AVAILABILITY_TYPES.HORIZONTAL });
  const { width } = useViewport();
  const isMobile = width <= BREAKPOINT_VALUES.xxl + 100;
  return (
    <>
      <Grid
        item
        container
        xl={12}
        className={clsx(
          classes.desktopContent,
          isMobile && classes.desktopContentPadding
        )}>
        <main id="main" className={classes.desktopGridContainer}>
          <Grid
            item
            container
            xl={8}
            className={classes.venueInformationContainer}>
            <Information venue={venue} />
            <Divider width="100%" />
            <DetailedLayout
              list={list}
              venue={venue}
              guests={guests}
              user={user}
              time={time}
              date={date}
              loadingAvailability={loadingAvailability}
              handleClick={handleClick}
              eventList={hasRelatedEvents && eventList}
              pageType={PAGE_TYPE.VENUE_DETAILS_PAGE}
            />
          </Grid>
          <Grid item container xl={4} className={classes.desktopSidebar}>
            <section aria-label="contact information">
              <ContactInfo venue={venue} />
            </section>
          </Grid>
        </main>
      </Grid>
    </>
  );
};

export default DesktopVenueLayout;
